exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:768px){.md-fixed-botoom .course-content[data-v-78c5277a]{margin-bottom:68px}}.completedBtn[data-v-78c5277a]{width:240px;max-width:240px}@media (max-width:768px){.btn-w-100[data-v-78c5277a],.completedBtn[data-v-78c5277a]{width:100%;max-width:100%}}.change-font-btn[data-v-78c5277a]{right:15px;top:14px;z-index:1080}.modal-open .change-font-btn[data-v-78c5277a],.sidebar-open .change-font-btn[data-v-78c5277a]{display:none!important}", ""]);

// exports
